export default __webpack_public_path__ + "static/fr-map-33479c4bb47d10734a78f84a24b1d08c.png";